export default __webpack_public_path__ + "static/media/realtor.ebf5c6f1.png";